import moment from 'moment';
import Cookies from 'universal-cookie';

const postStartBreakPayload = (formData) => {
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;
  return {
    operatorPresenceId: formData?.monitoringStatus?.presence?.id,
    breakTypeId: formData?.breakDetail?.id,
    startedAt: moment.tz(timezone).format('YYYY-MM-DD HH:mm:ss'),
  };
};

export default postStartBreakPayload;
